import React from "react";
import PageLabel from "../common/PageLabel";
import MutedText from "../common/MutedText";
import { Accordion, AccordionItem, Checkbox } from "@athena/forge";

export interface AppScopeMapping {
  [key: string]: {
    id: string;
    clientId: string;
    scopeName: string;
    clientName: string;
    grantStatus: string;
  }[];
}
export interface ScopeSelectionPropsType {
  title: string;
  description: string;
  emptyText: string;
  accordioHeading: { [key: string]: string };
  appScopeMapping: AppScopeMapping;
  toUpdateGrantIds: string[];
  addToUpdateGrantIds: (id: string) => void;
}

const ScopeList = ({
  appScopeMapping,
  toUpdateGrantIds,
  addToUpdateGrantIds,
}: ScopeSelectionPropsType): React.JSX.Element => {
  return (
    <>
      <div className="fe_u_margin--top-medium fe_u_margin--bottom-medium">
        {appScopeMapping &&
          Object.keys(appScopeMapping).map((key, index) => {
            return (
              <div className="fe_u_margin--top-medium" key={`${key}-${index}`}>
                <PageLabel
                  text={key}
                  fontSize="small"
                  fontWeight="semibold"
                  marginBottom="none"
                />
                {appScopeMapping[key].map(
                  (
                    scope: {
                      scopeName: string;
                      id: string;
                      grantStatus: string;
                    },
                    index: number,
                  ) => {
                    return (
                      <div
                        className="fe_u_margin--none"
                        key={`${scope.scopeName}-${index}`}
                      >
                        <Checkbox
                          className="fe_u_font-size--small"
                          aria-label={scope.scopeName}
                          description={scope.scopeName}
                          id={scope.id}
                          data-se-for-name={scope.scopeName}
                          checked={!toUpdateGrantIds.includes(scope.id)}
                          onChange={(): void => {
                            const id = scope.id;
                            addToUpdateGrantIds(id);
                          }}
                          data-testid={scope.id}
                        />
                      </div>
                    );
                  },
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

const ScopeSelection = ({
  title,
  description,
  emptyText,
  accordioHeading,
  appScopeMapping,
  toUpdateGrantIds,
  addToUpdateGrantIds,
}: ScopeSelectionPropsType): React.JSX.Element => {
  const totalScopes = Object.values(appScopeMapping).reduce(
    (acc, current) => acc + current.length,
    0,
  );
  const [accordioHeadingText, setaccordioHeadingText] = React.useState(
    accordioHeading.show,
  );
  return (
    <>
      <div className="fe_u_margin--top-medium"></div>
      <PageLabel text={title} fontSize="medium" />
      <MutedText
        className="uiam-header-description fe_u_font-size--small fe_u_text-align--left"
        text={description}
      />
      {totalScopes <= 5 && (
        <ScopeList
          title={title}
          description={description}
          emptyText={emptyText}
          accordioHeading={accordioHeading}
          appScopeMapping={appScopeMapping}
          toUpdateGrantIds={toUpdateGrantIds}
          addToUpdateGrantIds={addToUpdateGrantIds}
        />
      )}
      {totalScopes > 5 && (
        <Accordion className="fe_u_margin--top-small" id={title}>
          <AccordionItem
            padded={false}
            headingText={`${accordioHeadingText}`}
            onExpandedChange={() => {
              if (accordioHeadingText === accordioHeading.show) {
                setaccordioHeadingText(accordioHeading.hide);
              } else {
                setaccordioHeadingText(accordioHeading.show);
              }
            }}
          >
            <ScopeList
              title={title}
              description={description}
              emptyText={emptyText}
              accordioHeading={accordioHeading}
              appScopeMapping={appScopeMapping}
              toUpdateGrantIds={toUpdateGrantIds}
              addToUpdateGrantIds={addToUpdateGrantIds}
            />
          </AccordionItem>
        </Accordion>
      )}
      {appScopeMapping && Object.keys(appScopeMapping).length === 0 && (
        <MutedText
          className="uiam-header-description fe_u_font-size--medium fe_u_text-align--center"
          text={emptyText}
        />
      )}
    </>
  );
};

export default ScopeSelection;
